import * as actions from "../../actions/paymentMethod";

export interface PaymentMethodState {
	loading: any;
	items: any[];
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: PaymentMethodState = {
	loading: {},
	items: [],
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_PAYMENT_METHODS: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_PAYMENT_METHODS_SUCCESS: {
			return {
				...initialState,
				items: payload || []
			};
		}
		case actions.GET_PAYMENT_METHODS_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
